<template>
    <div class="history-coins-dialog">
        <div class="history-coins-dialog__header" v-if="!isLoading">
            <div class="history-coins-dialog__title">История получения баллов</div>
        </div>
        <div class="history-coins-dialog__total">
            <span class="history-coins-dialog__total-title">Сумма баллов:</span>
            <div class="history-coins-dialog__total-value">
                <total-coins :total-coins="spaceInTotalCoins(totalCoins)" />
            </div>
        </div>
        <main class="history-coins-dialog__main">
            <ul class="history-coins-dialog__list" v-if="historyCoins.length">
                <li class="history-coins-dialog__list-item" v-for="(coins, index) in historyCoins" :key="index">
                    <div class="history-coins-dialog__list-item-coins">
                        <span class="history-coins-dialog__list-item-coins-value"
                            >+{{ spaceInTotalCoins(coins.coins) }}</span
                        >
                        <span class="history-coins-dialog__list-item-coins-partner" v-if="!coins.isReferral">{{
                            coins.partnerName
                        }}</span>
                        <span class="history-coins-dialog__list-item-coins-partner" v-if="coins.isReferral">{{
                            getReferralText(coins.coins)
                        }}</span>
                    </div>
                    <div class="history-coins-dialog__list-item-date" v-if="coins.createdAt">
                        Начислено: {{ parseDate(coins.createdAt) }}
                    </div>
                </li>
            </ul>
            <div class="history-coins-dialog__empty" v-else>Данные об истории получения баллов отсутствуют.</div>
        </main>
    </div>
</template>

<script>
import { get } from '@/tools/http';
import moment from 'moment';
import TotalCoins from './TotalCoins.vue';
import spaceInNumber from '@/tools/spaceInNumber';
import pluralize from '@/tools/pluralize.js';

export default {
    name: 'HistoryCoinsDialog',
    components: {
        TotalCoins,
    },
    data() {
        return {
            historyCoins: [],
            isLoading: true,
        };
    },
    computed: {
        totalCoins() {
            return this.historyCoins.reduce((acc, item) => acc + item.coins, 0);
        },
    },
    methods: {
        async fetchHistoryCoins() {
            const historyCoins = await get('coins', `api/score/history`, {}, true);
            this.historyCoins = historyCoins.data;
        },
        parseDate(date) {
            return moment(date).format('DD.MM.YYYY');
        },
        spaceInTotalCoins(totalCoins) {
            return spaceInNumber(totalCoins);
        },
        getReferralText(count) {
            return `${pluralize(count, 'Балл', 'Балла', 'Баллов')} за активность друга`;
        },
    },
    async mounted() {
        await this.fetchHistoryCoins();
        this.isLoading = false;
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.history-coins-dialog {
    padding: mrem(30) mrem(8);

    @include on-desktop {
        padding: 0;
        border-radius: rem(10);
    }

    * {
        font-family: 'Montserrat', sans-serif;
    }

    @include on-desktop {
        min-height: 0;
    }

    &__main {
        @include on-desktop {
            height: rem(580);
            overflow: auto;
            padding-right: rem(20);
        }
    }

    &__title {
        margin: 0;
        font-size: mrem(18);
        line-height: mrem(24);
        font-weight: 600;
        margin-bottom: mrem(24);
        color: #251f45;

        @include on-desktop {
            font-size: rem(26);
            line-height: rem(32);
            font-weight: 600;
            margin-bottom: rem(24);
        }
    }

    &__total {
        display: flex;
        align-items: center;
        margin-bottom: mrem(24);

        @include on-desktop {
            margin-bottom: rem(24);
        }
    }

    &__total-title {
        margin-right: mrem(10);
        font-weight: 600;
        font-size: mrem(16);
        line-height: mrem(22);
        color: #251f45;

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(22);
            margin-right: rem(10);
        }
    }

    &__total-value {
        font-weight: 600;
    }

    &__list {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    &__list-item {
        margin-bottom: mrem(24);
        @include on-desktop {
            margin-bottom: rem(24);
        }
    }

    &__list-item-coins {
        display: flex;
        align-items: center;
        gap: mrem(5);
        font-weight: 600;

        @include on-desktop {
            gap: rem(5);
        }
    }

    &__list-item-coins-value {
        font-size: mrem(16);
        line-height: mrem(22);
        font-weight: 600;
        color: #68c87a;
        @include on-desktop {
            font-size: rem(16);
            line-height: rem(22);
        }
    }

    &__list-item-coins-partner {
        font-size: mrem(16);
        line-height: mrem(22);
        font-weight: 500;
        @include on-desktop {
            font-size: rem(16);
            line-height: rem(22);
        }
    }

    &__list-item-date {
        font-size: mrem(16);
        line-height: mrem(22);
        color: #98a0a9;
        margin-top: mrem(5);
        font-weight: 400;
        @include on-desktop {
            margin-top: rem(5);
            font-size: rem(16);
            line-height: rem(22);
        }
    }

    &__empty {
        padding: mrem(12) mrem(16);
        border-radius: mrem(16);
        font-weight: 400;
        font-size: mrem(16);
        line-height: mrem(24);
        color: #2a2626;
        background: #f7f9fc;

        @include on-desktop {
            padding: rem(12) rem(20);
            border-radius: rem(16);
            font-size: rem(16);
            line-height: rem(24);
        }
    }
}
</style>
